import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../../api'

const initialState = {
  academicPlan: "",
  academicPlanDescription: "",
  academicProgram: "",
  academicProgramDescription: "",
  admitType: "",
  assignable: null,
  countryOfCitizenship: "",
  earlyAction: false,
  firstGen: false,

  homeCountry: "",
  lowSocioeconomic: false,
  priority: "",
  regularDecision: false,
  residency: "",
  rural: false,
  stage: "",
  termLabel: "",
  zip: "",
  
  // applicantEmployeeId: "",

  // buckeyeStudentLeadershipAcademy: "",

  // classRankPercentile: "",
  // classRankType: "",
  // classSize: "",
  // classStanding: "",
  // committeeId: "",
  // group: "",
  // groupName: "",
  // county: "",
  // dateAssigned: "",
  // dateOfBirth: "",

  // evaluationDate: "",

  // firstName: "",
  // highSchoolName: "",
  // highSchoolGPA: "",
  // highSchoolLocation: "",
  // highSchoolGraduationDate: "",

  // honors: false,
  // lastName: "",

  // middleInitial: "",
  // msp: false,

  // residency: "",
  // residencyCategory: "",

  // scholars: false,
  // siblings: "",

  // inprogressStatus: null,
  // status: "",
  // reason: ""
}

const transform = (data) => {
  let transformedData = {...data};

  // console.log("data: ", data);
  transformedData.earlyAction = data?.earlyAction === true ? "Yes" : "No"
  transformedData.regularDecision = data?.regularDecision === true ? "Yes" : "No"
  transformedData.lowSocioeconomic = data?.lowSocioeconomic === true ? "Yes" : "No"
  transformedData.firstGen = data?.firstGen ? "Yes" : "No"

  return transformedData
}

// function yesNoIfValid(b) {
//     if (![true, false].includes(b)) { return b; }
//     return b ? "Yes" : "No";
// }

const demographicsSlice = createSlice({
  name: 'applicant-detail-demographics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // has503 — also populate from the Scholars-specific details query (same payload shape).
    const onFulfilled = (state, { payload }) => {
      if (payload?.details?.demographics) {
        let newState = {};
        for (let key in initialState) {
          newState[key] = payload?.details?.demographics[key];
        }
        return transform(newState);
      }
    };
    builder.addMatcher(graphqlApi.endpoints.getApplicationDetails.matchFulfilled, onFulfilled);
    builder.addMatcher(graphqlApi.endpoints.getScholarsApplicationDetails.matchFulfilled, onFulfilled);
  }
});

export const selectDemographicData = (state) => state.demographicsSlice

export default demographicsSlice.reducer;